var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadestrandSted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.59 15.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cirkel"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 0,
    width: 15.59,
    height: 15.59,
    rx: 7.8,
    ry: 7.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.96,3.4c.26.4.47.86.62,1.37.04.13.17.2.3.16.81-.28,1.34-.58,1.29-.83-.31-1.47-2.02-2.4-3.95-2.18-.02,0-.02.02,0,.03.21.09.45.21.71.39.4.28.75.64,1.03,1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.7,5.86c.13,0,.22-.13.2-.25-.08-.48-.09-.95-.03-1.4.06-.46.2-.91.41-1.32.15-.3.32-.55.47-.73.01-.01,0-.03-.02-.03-1.78.57-2.95,2.04-2.65,3.46.06.26.71.33,1.62.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.23,10.44l-2.39-.84c-.11-.04-.22-.07-.33-.1-.79-.23-1.6-.28-2.4-.16l-.64-3.83c.55-.11,1.1-.25,1.58-.39.12-.04.19-.16.16-.28-.15-.5-.35-.95-.61-1.34-.27-.41-.6-.76-.99-1.03-.34-.24-.66-.38-.87-.45-.03-.01-.06-.02-.08-.03-.03-.01-.07-.01-.1,0,0,0,0,0,0,0-.07.01-.15.03-.22.05-.04,0-.08.03-.1.06-.16.18-.39.47-.59.87-.2.4-.34.83-.4,1.28-.06.44-.05.89.03,1.35.02.14.15.24.3.22.47-.05.98-.13,1.49-.23l.64,3.83c-.24.05-.48.11-.71.2l-.34.12s-1.94.53-2,.55c-.06.02-.12.06-.07.1.06.04.23.16.32.24.19.17.3.26.55.26s.36-.09.55-.26c.23-.2.54-.47,1.11-.47s.89.27,1.11.47c.19.17.29.26.55.26s.36-.09.55-.26c.23-.2.54-.47,1.11-.47s.88.27,1.11.47c.19.17.29.26.55.26,0,0,0,0,.01,0l1.05-.03c.1,0,.19-.07.2-.17.02-.1-.04-.2-.14-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.15,11.5c-.29,0-.42-.11-.62-.28-.23-.2-.51-.44-1.04-.44s-.82.24-1.04.44c-.2.17-.33.28-.62.28s-.42-.11-.62-.28c-.22-.2-.51-.44-1.04-.44s-.82.24-1.04.44c-.2.17-.33.28-.62.28s-.43-.11-.62-.28c-.23-.2-.51-.44-1.04-.44s-.82.24-1.04.44c-.2.17-.33.28-.62.28-.18,0-.32.14-.32.32s.14.32.32.32c.54,0,.82-.24,1.04-.44.2-.17.33-.28.62-.28s.43.11.62.28c.23.2.51.44,1.04.44s.82-.24,1.04-.44c.2-.17.33-.28.62-.28s.42.11.62.28c.23.2.51.44,1.04.44s.82-.24,1.04-.44c.19-.17.32-.28.62-.28s.42.11.62.28c.23.2.51.44,1.04.44.18,0,.32-.14.32-.32s-.14-.32-.32-.32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadestrandSted);
export default __webpack_public_path__ + "static/media/BADESTRAND-STED.01a73bacd4316ac5041e19f7072ad3df.svg";
export { ForwardRef as ReactComponent };